module.exports = __webpack_public_path__ + "img/myInfo.567c01d4.png";